(function () {
  function getScope(container) {
    return container.closest('slider-component') ||
           container.closest('.product__media-wrapper') ||
           document;
  }

  function getSlides(scope) {
    const list = scope.querySelector('[id^="Slider-Gallery-"]');
    return list ? Array.from(list.children) : [];
  }

  // Detect which slide is most visible in the viewport
  function getActiveIndex(scope) {
    const slides = getSlides(scope);
    if (!slides.length) return -1;

    let bestIdx = 0;
    let bestVisible = 0;

    slides.forEach((slide, i) => {
      const rect = slide.getBoundingClientRect();
      const visibleX = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
      const visibleY = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
      const visibleArea = visibleX * visibleY;

      if (visibleArea > bestVisible) {
        bestVisible = visibleArea;
        bestIdx = i;
      }
    });

    return bestIdx;
  }

  function getActiveImage(scope) {
    const idx = getActiveIndex(scope);
    if (!(idx === 0 || idx === 1)) return null; // only 1st or 2nd image

    const slides = getSlides(scope);
    const slide = slides[idx];
    return slide ? slide.querySelector('img') : null;
  }

  function applySpin(img, durationSeconds, rpm) {
    if (!img) return;

    let wrapper = img.closest('.ff-spin-target');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'ff-spin-target';
      img.parentNode.insertBefore(wrapper, img);
      wrapper.appendChild(img);
    }

    const secondsPerTurn = 60 / Math.max(0.1, rpm);
    const totalTurns = Math.max(0.01, rpm * (durationSeconds / 60));

    wrapper.style.animation = 'none';
    void wrapper.offsetHeight;

    wrapper.classList.add('ff-spinning');
    wrapper.style.animationName = 'ff-spin-rotate';
    wrapper.style.animationDuration = `${secondsPerTurn}s`;
    wrapper.style.animationTimingFunction = 'linear';
    wrapper.style.animationIterationCount = `${totalTurns}`;
    wrapper.style.animationFillMode = 'none';

    wrapper.addEventListener('animationend', () => {
      wrapper.style.animation = 'none';
      wrapper.classList.remove('ff-spinning');
    }, { once: true });
  }

  function initSpinControls(container) {
    const scope = getScope(container);
    const button = container.querySelector('[data-ff-spin-btn]');
    const duration = parseFloat(container.getAttribute('data-ff-spin-duration')) || 3.5;
    const rpm = parseFloat(container.getAttribute('data-ff-spin-rpm')) || 60;
    if (!button) return;

    button.addEventListener('click', () => {
      const img = getActiveImage(scope);
      if (img) applySpin(img, duration, rpm);
    });

    function updateButtonVisibility() {
      const idx = getActiveIndex(scope);
      button.style.display = (idx === 0 || idx === 1) ? 'inline-flex' : 'none';
    }

    updateButtonVisibility();
    window.addEventListener('scroll', updateButtonVisibility, true);
    window.addEventListener('resize', updateButtonVisibility, true);
    window.addEventListener('orientationchange', updateButtonVisibility, true);
  }

  function initAll() {
    document.querySelectorAll('[data-ff-spin-root]').forEach(initSpinControls);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
